<template>
    <section class="p-2 widget my-2">
        <div class="row">
            <div class="col-12">
                <a
                    class="font-weight-bold float-right "
                    :class="
                        canEditClientEmr
                            ? 'text-primary cursor-pointer'
                            : 'text-muted cursor-not-allowed'
                    "
                    @click="canEditClientEmr ? editSkills() : null"
                    >Edit</a
                >

                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0">What I am good at</p>
                    <ul>
                        <li v-for="t in patient.what_i_am_good_at">{{ t }}</li>
                    </ul>
                </div>
                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0 mt-2">What I need help with</p>
                    <ul>
                        <li v-for="t in patient.what_i_need_help_with">{{ t }}</li>
                    </ul>
                </div>
                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0 mt-2">How to support me</p>
                    <ul>
                        <li v-for="t in patient.how_to_support_me">{{ t }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <modal-component
            :id="'patient-skills'"
            :title="modal.title"
            :visible="modal.visible"
            @close="resetModal()"
        >
            <div class="">
                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0">What I am good at</p>
                    <div class="form-group row mb-1">
                        <div class="form-group col-10 mb-1">
                            <input
                                type="text"
                                v-model="what_i_am_good_at"
                                class="form-control-sm form-control"
                            />
                        </div>
                        <div class="form-group col-2 mb-1">
                            <button
                                class="btn btn-sm btn-primary font-weight-bold text-uppercase link-primary text-white"
                                @click="addItem('what_i_am_good_at')"
                            >
                                Add
                            </button>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(t, i) in payload.what_i_am_good_at" class="mb-0">
                            {{ t }}
                            <i
                                v-tooltip="`Remove`"
                                class="fa fa-trash-o text-danger cursor-pointer ml-2"
                                @click="removeItem('what_i_am_good_at', i)"
                            ></i>
                        </li>
                    </ul>
                </div>

                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0 mt-2">What I need help with</p>
                    <div class="form-group row mb-1">
                        <div class="form-group col-10 mb-1">
                            <input
                                type="text"
                                v-model="what_i_need_help_with"
                                class="form-control-sm form-control"
                            />
                        </div>
                        <div class="form-group col-2 mb-1">
                            <button
                                class="btn btn-sm btn-primary font-weight-bold text-uppercase link-primary text-white"
                                @click="addItem('what_i_need_help_with')"
                            >
                                Add
                            </button>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(t, i) in payload.what_i_need_help_with" class="mb-0">
                            {{ t }}
                            <i
                                v-tooltip="`Remove`"
                                class="fa fa-trash-o text-danger cursor-pointer ml-2"
                                @click="removeItem('what_i_need_help_with', i)"
                            ></i>
                        </li>
                    </ul>
                </div>

                <div class="trait-list">
                    <p class="text-uppercase font-weight-bold mb-0 mt-2">How to support me</p>
                    <div class="form-group row mb-1">
                        <div class="form-group col-10 mb-1">
                            <input
                                type="text"
                                v-model="how_to_support_me"
                                class="form-control-sm form-control"
                            />
                        </div>
                        <div class="form-group col-2 mb-1">
                            <button
                                class="btn btn-sm btn-primary font-weight-bold text-uppercase link-primary text-white"
                                @click="addItem('how_to_support_me')"
                            >
                                Add
                            </button>
                        </div>
                    </div>
                    <ul>
                        <li v-for="(t, i) in payload.how_to_support_me" class="mb-0">
                            {{ t }}
                            <i
                                v-tooltip="`Remove`"
                                class="fa fa-trash-o text-danger cursor-pointer ml-2"
                                @click="removeItem('how_to_support_me', i)"
                            ></i>
                        </li>
                    </ul>
                </div>

                <button
                    class="btn btn-sm btn-primary text-white font-weight-bold float-right text-uppercase mt-3"
                    @click.prevent="saveSkills()"
                >
                    Save
                </button>
            </div>
        </modal-component>
    </section>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
import { permissions } from "../../plugins/permissions";

export default {
    name: "PatientSkills",
    props: ["patient"],
    mixins: [permissions],
    components: { ModalComponent },
    data() {
        return {
            modal: {
                visible: false,
                title: "Edit Patient Skills",
            },
            payload: {
                what_i_am_good_at: [],
                what_i_need_help_with: [],
                how_to_support_me: [],
            },
            what_i_am_good_at: null,
            what_i_need_help_with: null,
            how_to_support_me: null,
        };
    },
    methods: {
        editSkills() {
            this.modal.visible = true;
            this.payload.what_i_am_good_at = this.patient.what_i_am_good_at
                ? [...this.patient.what_i_am_good_at]
                : [];
            this.payload.what_i_need_help_with = this.patient.what_i_need_help_with
                ? [...this.patient.what_i_need_help_with]
                : [];
            this.payload.how_to_support_me = this.patient.how_to_support_me
                ? [...this.patient.how_to_support_me]
                : [];
        },

        resetModal() {
            this.modal.visible = false;
            this.what_i_am_good_at = [];
            this.what_i_need_help_with = [];
            this.how_to_support_me = [];
            this.payload = {
                what_i_am_good_at: [],
                what_i_need_help_with: [],
                how_to_support_me: [],
            };
        },

        addItem(list) {
            this.payload[list].push(this[list]);
            this[list] = null;
        },

        removeItem(list, index) {
            this.payload[list].splice(index, 1);
        },

        saveSkills() {
            if (!this.canEditClientEmr) return;
            const payload = { ...this.payload };
            axios
                .patch(`/api/patients/${this.patient.id}`, payload)
                .then(r => {
                    this.$emit("patient-saved");
                    this.resetModal();
                })
                .catch(e => {
                    console.error(e);
                });
        },
    },
};
</script>
